import React from 'react'
import ReactDOMServer from 'react-dom/server'
import * as FeatherIcons from 'feather-icons-react'
import { IconPack, IconDefinition, ExportArgs, svgStringToPng } from './types'

function formatDisplayName(name: string) {
  return name
    .replace(/Icon$/, '')
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/([A-Z])([A-Z][a-z])/g, '$1 $2')
    .replace(/^./, (str) => str.toUpperCase())
}

const featherIconsEntries = Object.entries(FeatherIcons).filter(
  ([, value]) => typeof value === 'function'
)

const featherIconsPack: IconPack = {
  name: 'Feather Icons',
  icons: featherIconsEntries.map(([name, icon]) => ({
    name,
    displayName: formatDisplayName(name),
    icon,
    pack: 'feather-icons',
  })),
  getIconComponent: (
    icon: IconDefinition,
    size?: number,
    color?: string,
    rotate?: number
  ) => {
    const IconComponent = icon.icon
    return (
      <IconComponent
        size={size || 24}
        color={color || 'currentColor'}
        style={{
          transform: rotate ? `rotate(${rotate}deg)` : undefined,
        }}
      />
    )
  },
  exportSVG: ({ icon, logo }: ExportArgs) => {
    const IconComponent = icon.icon
    const iconSize = logo.exactIconSize || 64
    const iconColor = logo.iconColor || '#000000'
    const bgColor = logo.backgroundColor || '#ffffff'
    const borderRadius = logo.borderRadius || 0
    const borderWidth = logo.borderWidth || 0
    const rotation = logo.rotate || 0
    const size = 256
    const iconX = 128 - iconSize / 2
    const iconY = 128 - iconSize / 2

    return ReactDOMServer.renderToStaticMarkup(
      <svg
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x={borderWidth / 2}
          y={borderWidth / 2}
          width={size - borderWidth}
          height={size - borderWidth}
          rx={borderRadius}
          ry={borderRadius}
          fill={bgColor}
          stroke={iconColor}
          strokeWidth={borderWidth}
        />
        <g transform={`rotate(${rotation},128,128)`}>
          <IconComponent
            size={iconSize}
            color={iconColor}
            x={iconX}
            y={iconY}
          />
        </g>
      </svg>
    )
  },
  exportPNG: async ({ icon, logo }: ExportArgs) => {
    const svg = featherIconsPack.exportSVG?.({ icon, logo })
    if (!svg) return undefined
    return await svgStringToPng(svg)
  },
}

export default featherIconsPack
